import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { BaseUrl } from "../../BaseUrl/BaseUrl";
import { Tooltip } from "@mui/material";
import { ServiceDiscounts } from "../../Components/enum";
import Batuk from "../../assets/images/new/fav-removebg-preview.png";
import { LoaderContext } from "../../AuthContext/AuthContext";
import banner from '../../assets/images/new/orderPageBanner.png'
import DailyPujaBookingBannerImg from "../../assets/images/new/DailyPoojaBookingBannerImg.png";
// import OrderDetails from "./OrderDetails";
const DailyBookingOrders = () => {
  const userID = JSON.parse(localStorage.getItem("userID"));
  const [orders, setOrders] = useState([]);
  const { setLoader, loader } = useContext(LoaderContext);
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    setLoader(true)
    axios
      .post(`${BaseUrl}/Get_AllMyOrder?USER_ID=${userID}&TYPE=DailyPuja`, {
        START: 1,
        END: 10,
        WORD: "None",
      })
      .then((response) => {

        console.log("Response...", response.data.DATA);
        setOrders(response.data.DATA);
        setLoader(false)
      });
  }, []);

  // const needSamagri = "yes";

  const orderDetails = (myorders) => {
    navigate("/daily-Booking-order-details", { state: { order: myorders } });
  };

  const SGST = 9;
  const CGST = 9;

  //   const tax = Math.round(
  //     ((SGST + CGST) / 100) * parseFloat(puja.CONVENIENCE_FEE)
  //   );

  //   const totalDays =
  //     (new Date(productBookingData.endDate) -
  //       new Date(productBookingData.startDate)) /
  //     (1000 * 60 * 60 * 24);

  //   const totalPrice =
  //     parseFloat(puja?.DP_PRICE || 0) * totalDays +
  //     (productBookingData.needSamagri === "yes"
  //       ? parseFloat(puja?.DP_SAMAGRI_PRICE * totalDays || 0)
  //       : 0) +
  //     parseFloat(puja?.CONVENIENCE_FEE || 0) +
  //     tax; //Tax amount

  console.log("orders", orders);

  const numberOfDays = (startDate, endDate) => {
    const totalDays =
      (new Date(endDate) - new Date(startDate)) / (1000 * 60 * 60 * 24);

    return totalDays + 1;
  };

  //   console.log(
  //     Number(myOrders?.DPB_PRICE || 0) *
  //       numberOfDays(myOrders.DPB_FROMDATE, myOrders.DPB_TODATE) +
  //       (needSamagri === "yes"
  //         ? Number(myOrders?.DP_SAMAGRI_PRICE || 0) *
  //           numberOfDays(myOrders.DPB_FROMDATE, myOrders.DPB_TODATE)
  //         : 0) +
  //       Number(myOrders?.CONVENIENCE_FEE || 0) +
  //       Math.round(((SGST + CGST) / 100) * Number(myOrders?.CONVENIENCE_FEE || 0))
  //   );

  const CalculateGrandTotal = (
    price,
    fromDate,
    toDate,
    samagriPrice,
    needSamagri,
    convenienceFee,
    discount
  ) => {
    // debugger;
    return (
      totalPrice(
        price,
        fromDate,
        toDate,
        samagriPrice,
        needSamagri,
        convenienceFee,
        discount
      ) +
      Math.round(
        (ServiceDiscounts.panditBookingDiscount / 100) *
        Number(
          totalPrice(
            price,
            fromDate,
            toDate,
            samagriPrice,
            needSamagri,
            convenienceFee,
            discount
          )
        )
      )
    );
  };

  const totalPrice = (
    price,
    fromDate,
    toDate,
    samagriPrice,
    needSamagri,
    convenienceFee,
    discount
  ) => {
    return (
      Number(price) * numberOfDays(fromDate, toDate) +
      Number(convenienceFee) +
      (needSamagri === "yes"
        ? Number(samagriPrice || 0) * numberOfDays(fromDate, toDate)
        : 0) -
      discount
    );
  };

  // const totatAmount = (
  //   price,
  //   fromDate,
  //   toDate,
  //   samagriPrice,
  //   needSamagri,
  //   convenienceFee
  // ) => {
  //   const res =
  //     Number(price) * numberOfDays(fromDate, toDate) +
  //     (needSamagri === "yes"
  //       ? Number(samagriPrice || 0) * numberOfDays(fromDate, toDate)
  //       : 0) +
  //     Number(convenienceFee) +
  //     Math.round(((SGST + CGST) / 100) * Number(convenienceFee));

  //   return res;
  // };

  function formatToIndianCurrency(amount) {
    if (!amount) return "";

    const [integerPart, decimalPart] = amount.toString().split(".");

    // Format the integer part using Indian numbering system
    const formattedIntegerPart = integerPart.replace(
      // Match groups of 3 digits initially, then groups of 2 digits
      /(\d)(?=(\d\d)+\d$)/g,
      "$1,"
    );

    // Return the formatted value with the decimal part (if present)
    return decimalPart !== undefined
      ? `${formattedIntegerPart}.${decimalPart}`
      : formattedIntegerPart;
  }
  return (
    <>
      <section className="page-header">
        <div className="page-header__bg" style={{ backgroundImage: `url(${DailyPujaBookingBannerImg})` }}></div>
        <div className="container" >
          <h2 className="page-header__title bw-split-in-left">Daily Puja Orders</h2>
        </div>
      </section>
      <div className="p-3 m-4 my-4">
        {orders?.length > 0 ? (
          <div className="row gx-4 gy-4" style={{ justifyContent: 'left' }}>
            {orders.map((order) => (
              <div className="col-xl-4 col-lg-4 col-md-6" key={order.id}>
                <div
                  className="card border-0 shadow-lg p-2 h-100"
                  onClick={() => orderDetails(order)}
                  style={{ cursor: "pointer" }}
                >
                  <div className="d-flex align-items-start">
                    <img
                      src={order?.DP_IMAGE || Batuk}
                      alt={order.DP_NAME}
                      className="rounded me-3"
                      style={{ width: "100px", height: "100px", objectFit: "contain" }}
                    />
                    {/* Flex column wrapper */}
                    <div className="d-flex flex-column justify-content-between w-100" style={{ minHeight: '100px' }}>
                      <div style={{ height: '7em' }}>
                        <h6
                          className="mb-1 text-truncate"
                          style={{
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                          }}
                          title={order.DP_NAME}
                        >
                          {order.DP_NAME}
                        </h6>
                        <span className="fw-bold text-muted">#{order.BookingID}</span>
                        <p className="mb-1">
                          <strong>Payment Status:</strong>{" "}
                          <span
                            style={{
                              color: order.PAYMENT_STATUS === "Pending" ? "red" : "green",
                              fontWeight: "600",
                            }}
                          >
                            {order.PAYMENT_STATUS}
                          </span>
                        </p>
                        <p className="mb-1 fw-bold">
                          <strong>Total Amount:</strong> ₹{" "}
                          {formatToIndianCurrency(order?.DPB_GrandTotal)}
                        </p>
                      </div>

                      {/* Button always at bottom */}
                      <div className="mt-3">
                        <button
                          className="Normal-app-btn"
                          style={{
                            padding: "5px 10px",
                            fontSize: "12px",
                          }}
                        >
                          View Details
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


            ))}
          </div>
        ) : loader === false ? (
          <div className="d-flex flex-column align-items-center justify-content-center vh-90 text-center mt-4">
            <img
              src={Batuk}
              alt="Empty Cart"
              className="img-fluid mb-3"
              style={{ maxWidth: "250px" }}
            />
            <h5 className="fw-bold">No orders found</h5>
            <button
              className="careox-btn"
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/services/puja-booking")}
            >
              Book now
            </button>
          </div>
        ) : (
          ""
        )}
      </div>
    </>

  );
};

export default DailyBookingOrders;
